var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIcon9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66732 6.66675H4.33398C3.08407 6.66675 2.45912 6.66675 2.02101 6.98508C1.87952 7.08788 1.75509 7.21228 1.65229 7.35375C1.33398 7.79188 1.33398 8.41681 1.33398 9.66675C1.33398 10.9167 1.33398 11.5416 1.65229 11.9797C1.75509 12.1212 1.87952 12.2456 2.02101 12.3484C2.45912 12.6667 3.08407 12.6667 4.33398 12.6667H11.6673C12.9173 12.6667 13.5422 12.6667 13.9803 12.3484C14.1218 12.2456 14.2462 12.1212 14.349 11.9797C14.6673 11.5416 14.6673 10.9167 14.6673 9.66675C14.6673 8.41681 14.6673 7.79188 14.349 7.35375C14.2462 7.21228 14.1218 7.08788 13.9803 6.98508C13.6788 6.76595 13.2887 6.69768 12.6673 6.67641",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66602 9H3.67275",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 8.99992C11.622 8.99992 12.6667 7.95525 12.6667 6.66659C12.6667 5.37792 11.622 4.33325 10.3333 4.33325C9.04467 4.33325 8 5.37792 8 6.66659C8 7.95525 9.04467 8.99992 10.3333 8.99992Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 12.6667L3.33398 14.6667",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 12.6667L12.666 14.6667",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33268 3.33325L7.66602 2.66659M12.9993 2.66659L12.3327 3.33325M10.3327 2.66659V1.33325",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon9);
export default __webpack_public_path__ + "static/media/SidebarIcon9.044ead87a36ba6b62cb42a35d54c5d63.svg";
export { ForwardRef as ReactComponent };